import api from 'containers/api'
import { selectToken } from 'containers/authentication/authenticationSlice'
import useDataLoader from 'containers/dataLoader'
import { useSelector } from 'react-redux'
import { IOrganization } from 'types'

const useGetCustomTables = (organization: IOrganization) => {
  const token = useSelector(selectToken)
  const getCustomTables = () => {
    return api.getCustomTables(token, organization.id)
  }

  return useDataLoader(getCustomTables)
}

export default useGetCustomTables
